module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av268-27d986c74bd28b424747bf0ee3427ecc.jpg";